import React, { useState } from 'react'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import BlockContent from './block-content'
import NextPrev from './nextprev'
import styled from 'styled-components'
import ContentTag from './content-tag'
import Button from './button'

const QuizResults = styled.section`
  display: ${({ show }) => show ? 'block' : 'none'};
  padding: 30px;
  border-radius: 15px;
  background: white;
`

const Result = ({ result, counter, questionsLength }) => {
  const { description, name, image, score } = result
  return (
    <div>
      {image && <img
        src={imageUrlFor(buildImageObj(image))
          .width(1200)
          .height(Math.floor((9 / 16) * 1200))
          .fit('crop')
          .url()} />
      }
      <h2>{name}</h2>
      {score && <h3>{counter}/{questionsLength} rette</h3>}
      <p>{description}</p>
    </div>
  )
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

const QuizQuestions = styled.section`
  padding: 30px;
  border-radius: 15px;
  background: white;
  width: 100%;

  .answer {
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
    margin: 1em 0;
  }

  header {
    display: flex;
    flex-direction: column;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    margin: 1em 0;
  }

  span {
    color: rgba(0,0,0, 0.6);
    font-size: .8em;
  }
  
  label {
    margin-left: 1em;
  }
`

const QuizArticle = styled.article`
  background: rgb(235, 237, 252);
  display: grid;
  min-height: calc(100vh - 70px);
  grid-template-columns: minmax(60px, auto) 2fr 3fr minmax(60px, auto);
  grid-gap: 30px;

  @media only screen and (max-width: 900px) {
    grid-template-columns: minmax(30px, auto) 1fr minmax(30px, auto);
    padding-bottom: 30px;
    > * {
      grid-column: 2/3 !important;
    }
  } 

  #quiz {
    display: flex;
    align-items: center;
  }

 header {
   grid-column: 2;
   display: flex;
   align-items: center;
   p {font-size:1.2em;}
    img {
      width: 100%;
      border-radius: 15px;
    }
  }

`

function Quiz(props) {
  const { title, questions, personalityTypes, results, _rawDescription, slug, toc, mainImage } = props
  let startState = null

  const personalityCountList = {}
  if (personalityTypes) {
    personalityTypes.forEach(type => {
      personalityCountList[type.personalityId.toLowerCase()] = 0
    })

    startState = personalityCountList
  } else if (results) {
    startState = 0
  }

  const [counter, setCount] = useState(startState)
  const questionsLength = questions.length
  const [questionCount, setQuestionCount] = useState(0);
  let currentQuestion = questions[questionCount]

  const nextQuestion = () => {
    setQuestionCount(questionCount + 1)
  }
  
  const [result, setResult] = results ? useState(results.sort((a, b) => b.score - a.score)[results.length - 1]) : useState(null)
  const [max, setMax] = useState(0)

  const addCount = (event) => {
    const type = event.target.value
    if (personalityTypes) {
      const count = counter[type] + 1
      const newMax = count > max

      newMax && setResult(personalityTypes.filter(t => t.personalityId.toLowerCase() === type)[0])
      setMax(newMax ? count : max)
      setCount({
        ...counter,
        [type]: count
      })
    } else {
      const count = type ? counter + 1 : counter
      const result = results.sort((a, b) => b.score - a.score).filter(r => r.score >= count)
      setResult(result[result.length - 1])
      type && setCount(counter + 1)
    }

    nextQuestion()
  }

  const reset = () => {
    setResult(null)
    setQuestionCount(0)
    personalityTypes ? setCount(personalityCountList) : setCount(0)
    setMax(0)
  }

  return (
    <QuizArticle className="framed">
      <NextPrev slug={slug} toc={toc} />
      <header>
        <div id="#info">

          {props.mainImage && mainImage.asset && (
            <img
              src={imageUrlFor(buildImageObj(mainImage))
                .width(1200)
                .height(Math.floor((9 / 16) * 1200))
                .fit('crop')
                .url()}
              alt={mainImage.alt}
            />
          )}
          <ContentTag type="Quiz" />
          <h1>{title}</h1>
          {_rawDescription && <BlockContent blocks={_rawDescription || []} />}
        </div>
      </header>
      <div id="quiz">
        {questionCount < questionsLength ? (
          <QuizQuestions show={questionCount < questionsLength}>
            <div id="question">
              <header>
                <span>Spørsmål {questionCount + 1}/{questionsLength}</span>
                <h2>{currentQuestion.question}</h2>
              </header>
              {shuffle(currentQuestion.answers).map((a, index) =>
                <div className="answer" key={a._key}>
                  <Button value={a.personalityId ? a.personalityId.toLowerCase() : a.isCorrect} onClick={(e) => addCount(e)} key={a._key}>{index + 1}</Button>
                  <label>{a.answer}</label>
                </div>
              )}
            </div>
          </QuizQuestions>
        ) : (
            <QuizResults id="quiz-results" show={questionCount === questionsLength}>
              <Result result={result} counter={counter} questionsLength={questionsLength} />
              <Button onClick={() => reset()}>Ta på nytt</Button>
            </QuizResults>
          )
        }
      </div>
    </QuizArticle>
  )

}

export default Quiz
